import React from 'react';
import NavigationBar from '../../../components/NavigationBar/NavigationBar';
import { isLocalizeAdded, LocalizePropType } from 'getaway-data-layer';
import './TariffPartnerView.less';
import { isDashboardScreen } from '../../../../utils';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import ListItem from '../../../components/ListItem/ListItem';
import BrandIcon from '../../../components/BrandIcon/BrandIcon';

type props = {
  localize: LocalizePropType;
  onClose: () => void;
  inviteLink: string;
  tariffPartnerEnabled: boolean;
  onSwitchValueChange: (arg: boolean) => void;
  onClickShare: () => void;
  onClickLink: () => void;
};

const TariffPartnerView = ({
  localize,
  inviteLink,
  tariffPartnerEnabled,
  onSwitchValueChange,
  onClose,
  onClickShare,
  onClickLink,
}: props) => {
  return (
    <div className="screen-container">
      <NavigationBar
        TitleTestId="TariffPartnerView-title"
        title={localize(`tariff.partner.title`)}
        description={localize(`tariff.partner.desc`)}
        showHelp
        onClose={onClose}
        showArrowBack={isDashboardScreen()}
      />
      <div
        className={
          isLocalizeAdded(localize, 'tariff.partner.faq')
            ? 'screen-body-faq'
            : 'screen-body'
        }
      >
        <div
          className={
            isLocalizeAdded(localize, 'tariff.partner.faq')
              ? 'screen-body-content-faq'
              : 'screen-body-content'
          }
        >
          <ListItem
            containerStyles={{ padding: '10px 0', margin: 0 }}
            title={localize('tariff.partner.switch.title')}
            showSeparator={!tariffPartnerEnabled}
            switchItem
            switchValue={Boolean(tariffPartnerEnabled)}
            onSwitchValueChange={onSwitchValueChange}
          />
          {tariffPartnerEnabled && inviteLink && (
            <>
              <div className="tariff-link-box">
                <div>{localize('tariff.partner.link.prefix')}</div>
                <strong className="tariff-invite-link" onClick={onClickLink}>
                  {inviteLink}
                </strong>
                <div
                  className="tariff-link-share-button"
                  onClick={onClickShare}
                >
                  <BrandIcon
                    name="shareColored"
                    style={{ width: 16, height: 16 }}
                  />
                  {localize('tariff.partner.link.share')}
                </div>
              </div>
            </>
          )}
          <div className="tariff-link-footnote">
            <div className="tariff-link-footnote-text">
              <Markdown rehypePlugins={[rehypeRaw]}>
                {localize('tariff.partner.link.footnote.md')}
              </Markdown>
            </div>
          </div>
        </div>

        {isLocalizeAdded(localize, 'tariff.partner.faq') && (
          <div className="faq">
            <Markdown rehypePlugins={[rehypeRaw]}>
              {localize('tariff.partner.faq')}
            </Markdown>
          </div>
        )}
        <div className="screen-vertical-space" style={{ height: 170 }} />
      </div>
    </div>
  );
};

export default TariffPartnerView;
